(function() {
  var jsonifyNotice, report;

  jsonifyNotice = require('../internal/jsonify_notice');

  report = function(notice, opts, promise) {
    var payload, req, url;
    url = opts.host + "/api/v3/projects/" + opts.projectId + "/create-notice?key=" + opts.projectKey;
    payload = jsonifyNotice(notice);
    req = new global.XMLHttpRequest();
    req.open('POST', url, true);
    req.send(payload);
    return req.onreadystatechange = function() {
      var resp;
      if (req.readyState === 4 && req.status === 200) {
        resp = JSON.parse(req.responseText);
        notice.id = resp.id;
        return promise.resolve(notice);
      }
    };
  };

  module.exports = report;

}).call(this);



// WEBPACK FOOTER //
// ./~/airbrake-js/lib/reporters/compat.js